import { Navigate, Outlet } from 'react-router-dom';

import { useSession } from '@/stores/session';

/**
 * Onboarding gate: an authenticated user with ZERO memberships is routed to
 * the create-school flow before entering the app shell. Mount inside
 * <RequireAuth> (session is already bootstrapped by then).
 */
export function RequireSchool() {
  const memberships = useSession(s => s.memberships);

  if (memberships.length === 0) {
    return <Navigate to="/onboarding/create-school" replace />;
  }

  return <Outlet />;
}
